<section class="hero-grid">
  <article class="hero-card dark">
    <h3>LML Payments Analysis</h3>
    <div class="hero-metrics">
      <div>
        @if (isLoading) {
          <app-loading-skeleton [count]="1" width="70%" height="10px" borderRadius="4px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="50%" height="30px" borderRadius="4px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="70%" height="10px" borderRadius="4px"></app-loading-skeleton>
        } @else {
          <p class="kpi-label">Losing Master Certification</p>
          <p class="kpi danger">{{ stats.losingMasterThisMonth | number }}</p>
          <small>Associates due by {{ formatRequiredByDate(stats.certificationRequiredByDate) }}</small>
        }
      </div>
      <div>
        @if (isLoading) {
          <app-loading-skeleton [count]="1" width="70%" height="10px" borderRadius="4px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="50%" height="30px" borderRadius="4px"></app-loading-skeleton> 
          <app-loading-skeleton [count]="1" width="70%" height="10px" borderRadius="4px"></app-loading-skeleton> 
        } @else {
          <p class="kpi-label">Losing LML Payments</p>
          <p class="kpi warn">{{ stats.losingLMLNextMonth | number }}</p>
          <small>Associates due by {{ formatRequiredByDate(stats.paymentRequiredByDate) }}</small>
        }
      </div>
    </div>
  </article>

  <article class="hero-card dark">
    <h3>Risk Summary</h3>
    <div class="hero-metrics">
      <div>
        @if (isRiskLoading) {
          <app-loading-skeleton [count]="1" width="70%" height="10px" borderRadius="4px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="45%" height="20px" borderRadius="4px"></app-loading-skeleton>
        } @else {
          <p class="kpi-label">High</p>
          <p class="kpi danger">{{ stats.riskSummary.high | number }}</p>
        }
      </div>
      <div>
        @if (isRiskLoading) {
          <app-loading-skeleton [count]="1" width="70%" height="10px" borderRadius="4px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="45%" height="20px" borderRadius="4px"></app-loading-skeleton>
        } @else {
          <p class="kpi-label">Medium</p>
          <p class="kpi warn">{{ stats.riskSummary.medium | number }}</p>
        }
      </div>
      <div>
        @if (isRiskLoading) {
          <app-loading-skeleton [count]="1" width="70%" height="10px" borderRadius="4px"></app-loading-skeleton>
          <app-loading-skeleton [count]="1" width="45%" height="20px" borderRadius="4px"></app-loading-skeleton>
        } @else {
          <p class="kpi-label">Low</p>
          <p class="kpi safe">{{ stats.riskSummary.low | number }}</p>
        }
      </div>
    </div>
  </article>
</section>
